import { Component, Input } from '@angular/core';
import { TranslateBlockDirective } from '@ngx-translate/core';
import { ButtonIconComponent } from '../../button-icon/button-icon.component';
import { DialogBase } from '../dialog-base/dialog-base';

@Component({
  selector: 'app-dialog-confirm',
  imports: [
    DialogBase,
    ButtonIconComponent,
    TranslateBlockDirective,
  ],
  templateUrl: './dialog-confirm.html',
  styleUrl: './dialog-confirm.css',
})
export class DialogConfirm {
  @Input()
  public title!: string;

  @Input()
  public message!: string;

  @Input()
  public iconLeft!: string;

  @Input()
  public isOpen: boolean = false;

  @Input()
  public buttonAction!: () => void;

  @Input()
  public confirmAction!: () => void;
}
